function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  addDeleteButtonListener();
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
    setTimeout(updateShippingNotification, 1250);
    });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  addDeleteButtonListener();
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
      
        // Update cart
        updateCartDrawer();
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

function addDeleteButtonListener() {

document.querySelectorAll(".cart-drawer-item-delete").forEach((deleteButton) => {
  deleteButton.addEventListener("click", async () => {
    var rootItemDelete = deleteButton;
    var key = rootItemDelete.getAttribute("data-line-item-key");
    // Ajax update
    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [key]: 0 } }),
    });

    if (res.ok) {
      const cartDataResponse = await fetch("/cart.js", {
        method: "get",
        headers: {
          Accept: "application/json",
        },
      });

      if (cartDataResponse.ok) {
        const cartData = await cartDataResponse.json();

        const itemCountElement = document.getElementById("cart-item-count");
        const subtotalElement = document.getElementById("cart-subtotal");

        itemCountElement.textContent = cartData.item_count + " items";
        subtotalElement.textContent = "$" + (cartData.total_price / 100).toFixed(2); // Format the price as needed
      } else {
        console.error("Failed to fetch updated cart data.");
      }

      rootItemDelete.parentElement.parentElement.remove();
      setTimeout(updateShippingNotification, 250);
    } else {
      console.error("Failed to update the cart.");
    }
  });
});
}


addCartDrawerListeners();

document.querySelectorAll('button[name="add"]').forEach((button) => {
  button.addEventListener("click", async (e) => {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(button.closest("form")),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});



// Function to update the shipping notification
function updateShippingNotification() {

  var cartTotalElement = document.querySelector("#cart-subtotal");
  var cartTotal = parseFloat(cartTotalElement.textContent.replace(/[^0-9.-]+/g, ""));
  var difference = (shipping_threshold - cartTotal);
  console.log(shipping_threshold);
  var shippingNotification = document.querySelector(".shipping-notification");

  if (difference > 0) {
    shippingNotification.textContent = "You are $" + difference.toFixed(2) + " away from free shipping";
  } else {
    shippingNotification.style.display = "none";

  }
}




